import _Promise from "@babel/runtime-corejs2/core-js/promise";
import { login, logout, getInfo, refreshToken } from '@/api/user';
import { fetchRoleAuthList } from '@/api/role';
import { getToken, setToken, removeToken, setExpire } from '@/utils/auth';
import { resetRouter } from '@/router';
import Cookies from 'js-cookie';
import { fetchCorporationBalanceList } from '@/api/balance';
import { checkRole } from '@/utils/permission'; // 权限判断函数
const state = {
  token: getToken(),
  name: '',
  roles: [],
  corporation: {},
  corporationID: 0,
  corporationName: '',
  balance: 0,
  expire: Number(Cookies.get('expire') || 0),
  user: {},
  roleAuthList: {}
};
const mutations = {
  SET_TOKEN: (state, {
    token,
    expire
  }) => {
    state.token = token;
    setToken(token, expire);
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_ROLE: (state, role) => {
    state.roles = role;
  },
  SET_CORPORATION_ID: (state, id) => {
    state.corporationID = id;
  },
  SET_CORPORATION: (state, corporation) => {
    state.corporation = corporation;
  },
  SET_CORPORATION_NAME: (state, cpname) => {
    state.corporationName = cpname;
  },
  SET_EXPIRE: (state, data) => {
    state.expire = data;
    setExpire(data, new Date(setExpire));
  },
  SET_USER: (state, data) => {
    state.user = data;
  },
  SET_ROLE_AUTH_LIST(state, data) {
    state.roleAuthList = data;
  }
};
const actions = {
  // user login
  login({
    commit
  }, data) {
    const {
      email,
      password
    } = data.userInfo;
    return new _Promise((resolve, reject) => {
      login({
        captcha: data.query,
        email: email.trim(),
        password: password
      }).then(response => {
        const data = response.data;
        commit('SET_TOKEN', {
          token: data.token,
          expire: data.expire
        });
        commit('SET_EXPIRE', new Date(data.expire).getTime());
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
  // get user info
  getInfo({
    commit,
    state
  }, data) {
    return new _Promise((resolve, reject) => {
      getInfo(data || state.token).then(async response => {
        const data = response.data;
        // data['roles'] = ['system_user', 'administrator']

        if (!data) {
          reject('Verification failed, please Login again.');
        }
        data['roles'] = data.role.reduce((acc, cur) => {
          acc.push(cur.alias);
          return acc;
        }, []);
        const {
          username
        } = data;
        // data['roles'] = [role]
        commit('SET_USER', data);
        commit('SET_NAME', username);
        commit('SET_CORPORATION_NAME', data.corporation.name);
        commit('SET_CORPORATION_ID', data.corporation_id);
        commit('SET_CORPORATION', data.corporation);
        commit('SET_ROLE', data.roles);
        fetchCorporationBalanceList(checkRole('administrator') ? 0 : data.corporation_id).then(resp => {
          if (resp.data && resp.data.length > 0) {
            state.balance = resp.data[0].balance / 100;
          }
        });
        try {
          const {
            data
          } = await fetchRoleAuthList();
          commit('SET_ROLE_AUTH_LIST', data);
        } catch (error) {
          console.error(error);
          resolve(error);
        }
        resolve(data);
      }).catch(error => {
        commit('SET_TOKEN', '');
        commit('SET_EXPIRE', 0);
        state.roles = [];
        removeToken();
        reject(error);
      });
    });
  },
  // user logout
  logout({
    commit,
    state
  }) {
    return new _Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '');
        commit('SET_EXPIRE', 0);
        state.roles = [];
        removeToken();
        resetRouter();
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
  // remove token
  resetToken({
    commit
  }) {
    return new _Promise(resolve => {
      commit('SET_TOKEN', '');
      commit('SET_EXPIRE', 0);
      state.roles = [];
      removeToken();
      resolve();
    });
  },
  refreshToken({
    commit
  }) {
    return new _Promise((resolve, reject) => {
      refreshToken().then(response => {
        var _response$data, _response$data2, _response$data3;
        commit('SET_TOKEN', {
          token: response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.token,
          expire: response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.expire_at
        });
        commit('SET_EXPIRE', new Date(response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.expire_at).getTime());
        resolve(response);
      }).catch(data => {
        commit('SET_TOKEN', '');
        commit('SET_EXPIRE', 0);
        removeToken();
        reject({
          ...data
        });
      });
    });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};